
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../../components/utils/Loader';
import useFetch from '../../../hooks/useFetch';
import axios from "axios";
import jsPDF from "jspdf";

const BloomAnalysisCalculator = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(authState.user._id);
  const [userName, setUserName] = useState(authState.user.name);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [questions, setQuestions] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const bloomLevels = [
      { 
          level: 'Remembering', 
          keywords: ['define', 'list', 'recall', 'identify', 
                    'परिभाषित करा', 'यादी द्या', 'सांग', 'स्मरण करा', 'ओळखा', 
                    'परिभाषित करें', 'सूचीबद्ध करें', 'पहचानें', 'कोणत्या'] 
      },
      { 
          level: 'Understanding', 
          keywords: ['describe', 'explain', 'summarize', 'interpret', 
                    'स्पष्टीकरण द्या', 'वर्णन करा', 'समजावून सांगा', 'अर्थ लावा', 'स्पष्ट करा', 
                    'समझाएं', 'व्याख्या करें', 'व्याख्या करना', 'विशद करा', 'म्हणजे', 'स्पष्ट करा', 'समजावून सांगा'] 
      },
      { 
          level: 'Applying', 
          keywords: ['use', 'implement', 'solve', 'apply', 
                    'उपयोग करा', 'अंमलबजावणी करा', 'सोडवा', 'लागू करा', 'प्रयत्न करा', 
                    'लागू करें', 'हल करें', 'उपयोग करना'] 
      },
      { 
          level: 'Analyzing', 
          keywords: ['compare', 'contrast', 'differentiate', 'examine', 
                    'तुलना करा', 'फरक सांगा', 'परीक्षण करा', 'तपासणी करा', 'अवलोकन करा', 
                    'अभ्यास करा', 'विश्लेषण करें', 'तुलना करें', 'अवलोकन करना'] 
      },
      { 
          level: 'Evaluating', 
          keywords: ['justify', 'defend', 'assess', 'critique', 
                    'मूल्यमापन करा', 'समीक्षा करा', 'न्याय द्या', 'परख करा', 'निर्णय घ्या', 
                    'मूल्यांकन करें', 'निर्णय लें', 'समालोचना करें'] 
      },
      { 
          level: 'Creating', 
          keywords: ['design', 'construct', 'compose', 'develop', 
                    'डिझाइन करा', 'बांधकाम करा', 'विकसित करा', 'निर्माण करा', 'संयोजन करा', 
                    'निर्माण करें', 'विकसित करें', 'डिजाइन करें'] 
      }
  ];


  const analyzeQuestions = async () => {
    try {
      if (!questions || questions.length === 0) {
        return setResults('At least one valid question is required');
      }
  
      // Convert string input into an array if needed
      let formattedQuestions = Array.isArray(questions)
        ? questions
        : questions.split(/\r?\n|,\s*/).map(q => q.trim()).filter(q => q);
  
      if (formattedQuestions.length === 0) {
        return setResults('At least one valid question is required');
      }
  
      const results = formattedQuestions.map(question => {
        const detectedLevel = bloomLevels.find(level =>
          level.keywords.some(keyword => question.toLowerCase().includes(keyword))
        )?.level || 'Unknown';
  
        return { question, level: detectedLevel };
      });
  
      setResults(results);
    } catch (error) {
      console.error('Error in analyzeQuestions:', error);
      setResults('An error occurred while analyzing questions.');
    }
  };

  const analyzeAndSaveQuestions = async () => {
    if (!questions.trim()) return;
    setLoading(true);
    try {
      const response = await axios.post("/api/bloom/analyze", { questions, userCode });
      setResults(response.data.resultString);
      // console.log(response.data.level);
    } catch (error) {
      console.error("Error analyzing questions:", error);
    }
    setLoading(false);
  };



  return (
    <div className="p-6 mx-auto bg-gray-600 shadow-lg rounded-lg">
      <h2 className="text-2xl text-yellow-200 font-bold mb-4">Bloom's Taxonomy Calculator</h2>
      <textarea
        className="w-full p-2 border rounded-md"
        style={{width: "100%", height: "250px"}}
        placeholder="Enter questions here..."
        value={questions}
        onChange={(e) => setQuestions(e.target.value)}
      ></textarea>
      <div className='flex flex-row justify-center'>
        <button
          onClick={analyzeQuestions}
          className="mr-8 mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Analyzing..." : "Analyze Questions"}
        </button>
        <button
          onClick={analyzeAndSaveQuestions}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Analyzing..." : "Analyze & Save Questions"}
        </button>
      </div>
      {Array.isArray(results) ? (
        results.map((item, index) => (
          <p key={index} className="p-2 border-b">
            {typeof item === 'string' ? item : `${item.question} - ${item.level}`}
          </p>
        ))
      ) : typeof results === 'string' ? (
        results.split('; ').map((item, index) => (
          <p key={index} className="p-2 border-b">{item.trim()}</p>
        ))
      ) : (
        <p className="p-2 border-b">{results}</p>
      )}
    </div>
  );
};

export default BloomAnalysisCalculator;
